import React from 'react';
import Layout from '../Layout';
import './UnderConstruction.css';

function UnderConstruction() {
  return (
    <Layout>
      <div id="under-construction-wrap">
        <h1>Feature not available yet</h1>
      </div>
    </Layout>
  );
}

export default UnderConstruction;
